import { render, staticRenderFns } from "./PriorityChart.vue?vue&type=template&id=46f4f240&"
import script from "./PriorityChart.vue?vue&type=script&lang=js&"
export * from "./PriorityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports